/* CARZAN MEATS — shared scroll-reveal trigger (Aug 2026)
   Watches every .czn-reveal / .czn-reveal--slide-left element on the
   page and adds .is-revealed the first time it scrolls into view.
   Honors an optional data-czn-delay="ms" attribute so specific
   effects (black-bar slide-outs, staggered stat reveals) can pause
   briefly before animating in, per direct instruction. Re-run on
   Shopify section load so theme-editor previews pick up new
   sections without a full page refresh. */
(function () {
  function initCznReveal(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('.czn-reveal:not([data-czn-bound]), .czn-reveal--slide-left:not([data-czn-bound])');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-czn-delay'), 10) || 0;
          window.setTimeout(function () {
            el.classList.add('is-revealed');
          }, delay);
          io.unobserve(el);
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );

    els.forEach(function (el) {
      el.setAttribute('data-czn-bound', 'true');
      io.observe(el);
    });
  }

  window.cznInitReveal = initCznReveal;
  document.addEventListener('DOMContentLoaded', function () {
    initCznReveal(document);
  });
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      initCznReveal(e.target);
    });
  }
})();
